<template>
  <div class="outbox">
    <router-view></router-view>
  </div>
</template>

<script>
import "@/assets/styles/font-awesome.min.css";
export default {
  name: 'app',
}
</script>
<style lang="scss">
@import "./assets/styles/reset.scss";
@import "./assets/styles/base.scss";
@import "./assets/styles/main.scss";
.outbox{
  width:100%;
  height:100%;
  overflow: auto;
  // -webkit-overflow-scrolling: touch;
  // overflow-x: scroll;
  // overflow-y: hidden;
  // -webkit-overflow-scrolling: touch;
}
</style>





// WEBPACK FOOTER //
// App.vue?92052b82